import * as actionTypes from './../actions/dietAction';

const initialState = {
  selected: [],
  selectedData: {},
  data: [],
  pending: true,
  error: null,
  ready: false,
  animalType: null,
};

const reducer = ( state = initialState, action ) => {
  switch ( action.type ) {
    case actionTypes.SELECT:
      let newSelectedData = {...state.selectedData};
      newSelectedData[state.data.data[state.animalType][action.selected].id]=state.data.data[state.animalType][action.selected].label;
      return {
        ...state,
        selected: [...state.selected, action.selected],
        selectedData: newSelectedData,
      };
    case actionTypes.REMOVE:
      const index = state.selected.indexOf(action.removed);
      let selectedArray = [...state.selected];
      let newSelectedData2 = {...state.selectedData};
      if (index > -1) {
        selectedArray.splice(index, 1);
        delete newSelectedData2[state.data.data[state.animalType][action.removed].id];
      }
      return {
        ...state,
        selected: selectedArray,
        selectedData: newSelectedData2,
      };
    case actionTypes.DEFAULT:
      return {
        ...state,
        selected: [],
        selectedData: {},
        ready: true,
        animalType: action.animalType,
      };
    case actionTypes.FETCH_DATA_PENDING:
      return {
        ...state,
        pending: true
      };
    case actionTypes.FETCH_DATA_SUCCESS:
      return {
        ...state,
        pending: false,
        data: action.data,
      };
    case actionTypes.FETCH_DATA_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error
      };
    default:
      return state;
  }
};

export default reducer;
